<template>
  <div class="room-details">
    <div class="room mt-3" v-for="(item,index) in room_arr" :key="item.id">
      <div class="room-title mb-2">{{ item.title }}
          <span v-if="item.assist">({{ item.assist }})</span>
      </div>
      <div class="room-info">
          <div class="room-banner">
            <img v-lazy="ImgPreUrl+item.pic[0]" height="14px" class="room-img gallery-img" @click="$emit('roomDetails',item)" @mouseenter="isZoomed = index" @mouseleave="isZoomed = -1" :style="{ transform: isZoomed==index ? 'scale(1.1)' : 'scale(1)' }"></img>
            <div class="room-pic-num">
              <i class="iconfont icon-tupian"></i>
              <span>{{ item.pic.length }}</span>
            </div>
          </div>
          <div class="room-price">
            <div class="room-price-info">
              <div><i class="iconfont icon-train_tickets_seat_lower_berth"></i><span>{{item.specs }}</span></div>
              <div><i class="iconfont icon-24gf-window"></i><span>{{ item.window  | formatVar('windowStyle')||'/'}}</span></div>
              <div><i class="iconfont icon-mianjizhanbi"></i><span>{{ item.area }}m²</span></div>
              <div><i class="iconfont icon-fangjian"></i><span>{{ item.num }}间</span></div>
            </div>
          </div>
      </div>
      <div class="room-price-btn">
        <span class="bottom-line" @click="$emit('roomDetails',item)">房间详情</span>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {
    room_arr: {}
  },
  data() {
    return {
      isZoomed:-1,
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
    .room {
        width: 47%;
        padding: 1%;
        background-color: #fff;
        border-radius: 6px;
        text-align: left;
    }
    .room-title{
        font-size: 18px;
        font-weight: bold;
    }
    .room-img{
        width: 206px;
        height: 120px;
        border-radius: 4px;
    }
    .room-banner{
      position: relative;
      height: 120px;
      overflow: hidden;
    }
    .room-pic{
        display: flex;
        justify-content:space-between;
        width: 206px;
        img{
            width: 100px;
            height: 56px;
            border-radius: 4px;
        }
    }
    .room-pic-num{
      position: absolute;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, .6);
      color: #fff;
      width: 34px;
      padding: 3px 0;
      border-radius: 4px 0 0 0;
      text-align: center;
      font-size: 12px;
      i{
        margin-right: 4px;
        font-size: 12px;
      }
  
    }
    .room-info{
        display: flex;
        justify-content: space-between;
    }
    .room-price{
      width: 60%;
      .room-price-info{
        display: flex;
        justify-content: space-between;
        flex-wrap:wrap;
        height: 120px;
        width: 100%;
        overflow: hidden;
        div{
            width: 48%;
            background-color: #f5f7fa;
            margin-bottom: 10px;
            border-radius: 4px;
            display: flex;
            height: 55px;
          i{
            text-align: center;
            font-size: 20px;
            line-height: 55px;
            padding: 0 20px;
          }
          span{
            line-height: 55px;
          }
        }
      }

    }
    .room-details{
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    .room-price-btn{
      text-align: center;
      color: #999;
      width: 100%;
      margin-top: 10px;
      border-radius: 4px;
      border-top: 1px #eee solid;
      padding-top: 10px;
      .room-num{
        float: left;
        line-height: 40px;
      }
      .bottom-line{
        background-color: var(--smtc-color-primary);
        color: #fff;
        height: 40px;
        width: 100px;
        display: block;
        float: right;
        border-radius: 4px;
        line-height: 40px;
        cursor: pointer;
      }
    }
    .icon-shixinjiantouxiangxia{
      font-size: 14px;
    }
  .gallery-img {
    object-fit: cover;
    cursor: pointer;
    transition: 
    transform 0.6s cubic-bezier(0.25, 0.8, 0.25, 1), /* 缩放过渡（使用缓动函数增强质感） */
    filter 0.6s ease; /* 可选：添加亮度变化过渡 */
  }
</style>
